import { get } from "svelte/store";
import { user, debug } from './stores.js';

const host = get(debug) ? 'http://localhost:7071' : 'https://components.azurewebsites.net';

async function apiRequest(method, func, queryParams = null, body = null) {
  try {
    let url = `${host}/api/${func}`;

    if (queryParams) {
      let query = new URLSearchParams(queryParams);
      url += "?" + query.toString();
    }

    if (body) body = JSON.stringify(body);

    const response = await fetch(url, {
      method,
      headers: {
        'x-functions-key': 'WtyJa2UxRuwRXVQLkYqIG1f7qqVbBSiCk3MJXD1DqK/O/EF4a48iXA==',
        'Content-Type': 'application/json'
      },
      body
    });

    if (response.ok) {
      let data;
      if (response.headers.get("content-type")?.includes("application/json"))
        data = await response.json();
      if (response.headers.get("content-type")?.includes("text/plain"))
        data = await response.text();
      
      return { ok: response.ok, status: response.statusText, data };
    } else {
      return { error: response.statusText }
    }
  } catch(e) { 
    return { error: e }
  }
}

export async function getAttributes() {
  return await apiRequest('GET', 'Attributes');
}

export async function getTags() {
  return await apiRequest('GET', 'Tags');
}

export async function testQuery(query, n = 100) {
  return await apiRequest('GET', 'Parts', { query: JSON.stringify(query), n });
}

export async function getComponentQueries() {
  return await apiRequest('GET', 'ComponentQueries', { user: get(user).userDetails });
}

export async function getComponentQuery(id) {
  return await apiRequest('GET', 'ComponentQueries', { id });
}

export async function getHistoryAll() {
  return await apiRequest('GET', 'History', { n: 20 });
}

export async function getComponentHistory(id, n) {
  return await apiRequest('GET', 'History', { id, n });
}

export async function getMacroHistory(n) {
  return await apiRequest('GET', 'MacroHistory', { n });
}

export async function getAllMacroHistory() {
  return await apiRequest('GET', 'MacroHistory');
}

export async function getFavoredSellers() {
  return await apiRequest('GET', 'FavoredSellers');
}

export async function upsertComponentQuery(query) {
  return await apiRequest('PUT', 'ComponentQueries', null, query);
}

export async function deleteComponentQuery(id) {
  return await apiRequest('DELETE', 'ComponentQueries', { id });
}

export async function subscribe(ids) {
  return await apiRequest('PUT', 'Subscriptions', null, { user: get(user).userDetails, ids });
}

export async function unsubscribe(ids) {
  return await apiRequest('DELETE', 'Subscriptions', null, { user: get(user).userDetails, ids });
}